var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebAssembly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_144)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654FF0",
    d: "M157.281 0C157.281 0.451765 157.281 0.903529 157.281 1.38039C157.281 17.5937 144.138 30.7325 127.929 30.7325C111.716 30.7325 98.5767 17.5895 98.5767 1.38039C98.5767 0.903529 98.5767 0.451765 98.5767 0L0 0V256H256V0H157.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.4656 137.96H76.4318L88.0146 199.647H88.2237L102.145 137.96H118.015L130.589 200.404H130.836L144.038 137.96H160.678L139.056 228.601H122.219L109.749 166.914H109.423L96.0752 228.601H78.9249L59.4656 137.96ZM179.806 137.96H206.553L233.115 228.601H215.613L209.836 208.431H179.367L174.908 228.601H157.862L179.806 137.96ZM189.988 160.301L182.588 193.556H205.62L197.124 160.301H189.988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#fff",
    rx: 60
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAssembly);
export default __webpack_public_path__ + "static/media/WebAssembly.24328b7f54854482afbedbe84b96cf28.svg";
export { ForwardRef as ReactComponent };